import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'csl-container-volume-card',
  standalone: true,
  templateUrl: './container-volume-card.component.html',
  styleUrl: './container-volume-card.component.css',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContainerVolumeCardComponent {
  public selected = input<boolean>(false);
  public disabled = input<boolean>(false);

  @HostBinding('class') get styles(): string {
    const base = `
      border
      rounded-[--container-volume-card-border-radius]
    `;
    const addStyles = `
      border-[--container-volume-card-border-color]
      bg-[--container-volume-card-bg-color]
      hover:border-[--container-volume-card-hover-border-color]
      hover:bg-[--container-volume-card-hover-bg-color]
      active:border-[--container-volume-card-active-border-color]
      active:bg-[--container-volume-card-active-bg-color]
    `;
    const selectedStyles = `
      border-[--container-volume-card-selected-border-color]
      bg-[--container-volume-card-selected-bg-color]
      hover:border-[--container-volume-card-selected-hover-border-color]
      hover:bg-[--container-volume-card-selected-hover-bg-color]
      active:border-[--container-volume-card-selected-active-border-color]
      active:bg-[--container-volume-card-selected-active-bg-color]
    `;
    const disabledStyles = `bg-[--input-disabled-bg-color]`;

    return `${base} ${this.selected() ? selectedStyles : addStyles} ${this.disabled() ? disabledStyles : ''}`;
  }
}
